jQuery(function ($) {

    // Šípka na podlahe – Pannellum prepisuje transform celého hotspotu, preto sa nakláňa vnútorný prvok.
    // Podlahu pod uhlom pitch vidíme skrátenú o (90° - |pitch|), takže o toľko šípku sklopíme dozadu.
    function floorArrow(hotSpotDiv, args) {
        let tilt = Math.min( 90 - Math.abs( args.pitch ), 75 );

        $(hotSpotDiv).append(
            '<span class="vr-tour--hotspot--arrow" style="--tilt: ' + tilt + 'deg; --rotate: ' + ( args.rotate || 0 ) + 'deg;">' +
                '<svg viewBox="0 0 100 60" aria-hidden="true"><path d="M8 52 50 14l42 38"/></svg>' +
            '</span>' +
            $('<span class="vr-tour--hotspot--title"></span>').text( args.title ).prop('outerHTML')
        );
    }

    // Virtuálna prehliadka – jedna Pannellum prehliadka, panorámy sú jej scény a prepínajú sa šípkami / náhľadmi
    function initTour(el) {
        let $tour = $(el);
        let scenes = $tour.data('vr-tour') || [];

        if ( !scenes.length ) return;

        let config = {
            default: {
                firstScene: 'scene-0',
                sceneFadeDuration: 800,
                autoLoad: true,
                showZoomCtrl: true,
                showFullscreenCtrl: false, // vlastné tlačidlo, aby boli šípky viditeľné aj na celej obrazovke
                compass: false,
                mouseZoom: true,
                hfov: 130,
                maxHfov: 160, // dovoliť odzoomovať viac než predvolených 120° (okraje sa už prehýbajú)
                hotSpotDebug: /[?&]vr-debug\b/.test( window.location.search ) // pitch/yaw kliknutia do konzoly
            },
            scenes: {}
        };

        scenes.forEach(function (scene, i) {
            config.scenes['scene-' + i] = {
                type: 'equirectangular',
                panorama: scene.panorama,
                hotSpots: ( scene.links || [] ).map(function (link) {
                    return {
                        type: 'scene',
                        sceneId: 'scene-' + link.to,
                        pitch: link.pitch,
                        yaw: link.yaw,
                        targetYaw: link.targetYaw,
                        scale: true,
                        cssClass: 'vr-tour--hotspot',
                        createTooltipFunc: floorArrow,
                        createTooltipArgs: { pitch: link.pitch, rotate: link.rotate, title: scenes[link.to].title }
                    };
                })
            };
        });

        let viewer = pannellum.viewer( $tour.find('.vr-tour--viewer')[0], config );
        let $label = $tour.find('.vr-tour--label');

        // názov aktuálnej miestnosti vľavo hore – scénu mení šípka v priestore
        $label.text( scenes[0].title );

        viewer.on('scenechange', function (sceneId) {
            $label.text( scenes[ parseInt( sceneId.replace('scene-', ''), 10 ) ].title );
        });

        // celá obrazovka pre celý blok vrátane názvu a náhľadov; kde to prehliadač nevie (iPhone), tlačidlo skryjeme
        let $fullscreen = $tour.find('.vr-tour--fullscreen');

        if ( document.fullscreenEnabled ) {
            $fullscreen.on('click', function () {
                if ( document.fullscreenElement ) {
                    document.exitFullscreen();
                } else {
                    el.requestFullscreen();
                }
            });
        } else {
            $fullscreen.hide();
        }

        // záložka sa skrýva cez display:none – po opätovnom zobrazení / zmene veľkosti treba prekresliť WebGL
        viewer.on('load', function () { viewer.resize(); });

        if ( window.ResizeObserver ) {
            new ResizeObserver(function () { viewer.resize(); }).observe(el);
        }
    }

    // inicializácia až keď je prehliadka viditeľná (skrytá záložka má nulovú veľkosť a WebGL by zlyhal)
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if ( !entry.isIntersecting ) return;

            observer.unobserve(entry.target);
            initTour(entry.target);
        });
    }, { rootMargin: '50px' });

    $('.vr-tour').each(function () {
        observer.observe(this);
    });

});
